export default {
	/***********************************************菜单名称****************************************************/
	"制单管理": "Production",
	"扫菲报工": "Scan",
	"手动报工": "Report",
	"每日工资": "Salary",
	"工资详情": "Salary details",
	"小组工资": "Team salary",
	"裁床管理": "Cutting bed",
	"裁片装箱": "Encasement",
	"汇报记录": "Record",
	"外发管理": "Outsource",
	"裁床收料": "Receiving",
	"供应商管理": "Supplier",
	"客户管理": "Client",
	"基础管理": "Base",
	"选择菲票": "Choose Philippines ticket",
	"品质检验":"Inspection",
	"领料管理":"Receive fabric",
	"松布管理":"Loose fabric",
	"松布幅宽":"Fabric width",
	"拉布管理":"Open cloth",

	/***********************************************登录页****************************************************/
	"登录": "Login",
	"欢迎登录": "Welcome",
	"请输入手机号": "Phone No",
	"请输入密码": "Password",

	/***********************************************首页home**************************************************/
	"切换语言": "Language",
	"退出": "Quit",

	/***********************************************制单管理**************************************************/
	"待接单": 'Waiting',
	"准备中": "In Prep", //太长就说 "In Prep"
	"进行中": "Ongoing",
	"已完成": "Finish",
	"已拒单": "Rejected",
	"请输入生产单号或款号": "Please input production order number or style number",

	/***********************************************制单汇报详情***********************************************/
	"附件上传": "Upload Attachment",
	"最多选择5个文件": "Choose up to 5 files",
	"上传文件": "Upload file",

	/***********************************************手动报工**************************************************/
	"色码量": "Color and Size",

	/***********************************************扫菲报工**************************************************/
	"节点选择": "Node Selection",
	"生产单号": "Production Order Number",
	"暂无": "N/A", //"Not Available"
	"菲票号": "Ticket Number",
	"制单数": "Order Number",
	"扎号": "Bundle Number",
	"总床次": "Total Cuts",
	"色": "Color",
	"码": "Size",
	"数量": "Quantity ",
	"清空": "Empty",
	"备注": "Remarks ",
	"当前已选择": "Chosen",
	"总裁数": "Total Pcs",

	/***********************************************每日工资**************************************************/
	"数量": "Amount",
	"提成": "Wage",
	"件": "P",
	"元": "￥", //

	/***********************************************工资详情**************************************************/
	"月收入": "Monthly Income",
	"年": "Year", // （如果是年累计， 要用YTD,Year to Date的缩写） 
	"月": "Month", //（如果是月累计， 要用MTD, Month to Date的缩写）
	"日": "Day", //今日么？ 那就Today）

	/***********************************************小组工资**************************************************/
	"汇总": "Summary",

	/***********************************************裁床管理**************************************************/
	"请输入裁床单号、款号或生产单号": "Search for cutting number, style number or work order number",
	"名称": "Name",
	"款号": "Style number",
	"合同号": "Contract number",
	"返回": "Return ",
	"汇报": "Report ",
	"开始拉布": "Start Spreading",
	"完成拉布": "Finish Spreading",
	"检片": "Part Inspection",

	/***********************************************裁片装箱*****************************************************/
	"请输入箱号": "Please input carton number",
	"共": "Total",
	"扎": "Bundle",
	"片": "Piece",
	"裁床单号": "Cutting number",
	"已装箱": "Packed",
	"未装箱": "To be packed",
	"部位": "Part",
	"确认装箱": "Verified",
	"颜色": "Color",
	"尺码": " Size ",
	"装箱详情": "Packing details",

	/***********************************************汇报记录*****************************************************/
	"生产单号": "Work Order No",
	"工厂款号": "Factory Model No",
	"总床次": "Total Cuts",
	"工序号/工序": "Procedure No. / Procedure",
	"请输入编码、简码、简称": "Please enter the code, short code, abbreviation",
	"审核通过": "Pass",
	"驳回": "Reject",
	"搜索": 'Search',
	"提示": "Hint",
	"汇报删除记录": "Delete record",

	/***********************************************外发********************************************************/
	"重新派单": "Subcontract",
	"新增外发": "New Subcontract",

	/***********************************************外发详情*****************************************************/
	"订单数量": "Order Qty",
	"订单单价": "Order Value",
	"派发公司": "Sub-contractor",
	"交货日期": "Delivery date",
	"派发备注": "Notes",
	"拒单": "Declined",
	"接单": "Accepted",
	"订单详情": "Order Details",
	"请选择日期": "Select date",
	"请输入订单数量": "Order quantity",
	"请输入订单单价": "Order value",
	"请选择派发公司": "Subcontractor",
	"请选择交货日期": "Delivery Date",

	/***********************************************收料详情*****************************************************/
	"收料详情": "Receiving details",

	/***********************************************供应商管理***************************************************/
	"编码": "Supplier Code",
	"类型": "Type",
	"正常": "Enabled",
	"停用": "Disabled",
	"待验厂": "Pending Inspection",

	/***********************************************供应商详情***************************************************/
	"简码": "Short Code",
	"简称": "Abbreviation",
	"供应商分类": "Supplier Category",
	"联系人": "Contacts",
	"联系人电话": "Phone",
	"地址": "Address",
	"供应商详情": "Supplier Details",

	/***********************************************客户管理***************************************************/
	"业务员": "Salesperson",
	"合作方式": "Cooperation Mode",
	"负责人": "Person in charge",
	"客户组别": "Client Group",
	"客户编号": "Client Number",
	"待审核": "Pending Verification",
	"电话": "Phone",
	"请输入名称": "Name",
	"请输入简称": "Abbreviation",
	"请输入负责人名称": "Person in charge",
	"请输入负责人电话": "Contact No",
	"请输入客户组别": "Client Group",
	"请输入客户编号": "Client Number",
	"请输入地址": "Address",
	"客户详情": "Client details",
	
	/***********************************************品质检验***************************************************/
	"时间":"Time",
	"客户":"Client",
	"地址":"Address",
	"检验中":"In the test",
	"待接收":"To receive", 
	"任务详情":"Task details",
	"正在检验":"Are inspection",
	"请按相应的检验要求和标准进行检验":"Please carry out inspection according to the corresponding inspection requirements and standards",
	"进入检验":"inspection",
	"查看进度":"schedule",
	"订单总数量":"Total order quantity",
	"已完成数量":"Quantity completed",
	"下单日期":"Date of order",
	"查货要求":"The requirements for inspection",
	"验货类型":"The inspection type",
	"交货日期":"The delivery date",
	"品类":"category",
	"部位尺寸":"Part size",
	"工艺说明":"Process description",
	
	
	/***********************************************领料管理***************************************************/
	"待提交":"Waiting to submit",
	"单据编号":"Receipt number",
	"制造单号":"Order no.",
	"备料员":"Stock part",
	"领料员":"Get people",
	"新增":"Add",
	"规格":"Specification",
	"车间库位":"Shop location",
	"单件用量":"Single dosage",
	"物料颜色":"Color",
	"本卷数量":"Quantity",
	"总数量":"All quantity",
	"移除":"Remove",
	"扫码":"Scan",
	"领料单详情":"picking Details",
	


	/***********************************************按钮类*****************************************************/
	"查看订单": "View order",
	"确定完成": "Finish",
	"扫描菲票": "Scan ticket",
	"节点汇报": "Node report",
	"删除": "Delete",
	"新增外发": "Add",
	"启用": "Enabled",
	"停用": "Disabled",
	"确定修改": "Amend",
	"确定": "Confirm",
	"取消": "Cancel",


	/***********************************************弹窗********************************************************/
	"是否确定删除": "Confirm deletion",
	"已删除": "Deleted",
	"暂无数据": 'No data',
	"全选": "Select All",
	"忽略并提交": "Ignore and Submit",
	"该节点没有配置工序,请先在PC端配置工序": "Configure the procedures on the PC first",
	"轻触照亮": "Torch",
	"将二维码放入框中，即可自动扫描": "Scan QR code"
}
